import broadcastHostEvent, {
  HOST_EVENT_PREFIX,
  FEATURE_FLAGS_CHANGED,
  FEATURE_FLAGS_REQUEST,
} from '@/utilities/mfe/broadcastHostEvent';
import deepClone from '@/utilities/deepClone';

// mutations that will trigger overrides to be reapplied on top
const recomputeMutations = new Set([
  'setFeatureFlags',
  'featureFlagOverrides/setOverride',
  'featureFlagOverrides/removeOverride',
  'featureFlagOverrides/clearOverrides',
]);

// Sends the effective flags to MFE listeners
const sendEffectiveFlagsToMfes = ({ flags, expire }) => {
  broadcastHostEvent(FEATURE_FLAGS_CHANGED, { flags: deepClone(flags), expire });
};

// plugin on top of other plugins to retain overrides in dev panel
const featureFlagOverridesPlugin = (store) => {
  store.subscribe((mutation, state) => {
    if (!recomputeMutations.has(mutation.type)) return;

    store.commit('setEffectiveFlags', {
      ...state.featureFlags.fuseboxFlags,
      ...state.featureFlagOverrides.flags,
    });
    sendEffectiveFlagsToMfes(state.featureFlags);
  });

  // sends the flags to MFEs that specifically request them
  window.addEventListener(`${HOST_EVENT_PREFIX}${FEATURE_FLAGS_REQUEST}`, () => {
    sendEffectiveFlagsToMfes(store.state.featureFlags);
  });
};

export default { plugin: featureFlagOverridesPlugin };
